import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import * as krakenModels from '@/model/config/krakenModels';
import { SessionWatcherEvent } from '@/model/session/kraken';

export type SessionWatcherCallback = Sender<SessionWatcherEvent>;

export const watchSession = () =>
  asyncCallback(async (callback: SessionWatcherCallback) => {
    const watcherOptions = {
      callback,
    };

    return krakenModels.sessionWatcher(watcherOptions);
  });
